import { createSlice } from '@reduxjs/toolkit'

export const pinnedItins = createSlice({
  name: 'pinnedItins',
  initialState: {
    pinnedItins: [],
    isPinSelected: false,
  },
  reducers: {
    setPinnedItins: (state, action) => {
      const priceKey = action.payload
      const index = state.pinnedItins.indexOf(priceKey)
      if (index !== -1) {
        state.pinnedItins.splice(index, 1)
        if (state.pinnedItins.length === 0) {
          state.isPinSelected = false
        }
      } else {
        state.pinnedItins.push(priceKey)
      }
    },
    clearAllPins: (state) => {
      state.pinnedItins = []
      state.isPinSelected = false
    },
    setIsPinSelected: (state, action) => {
      state.isPinSelected = action.payload
    },
  },
})

export const { setPinnedItins, clearAllPins, setIsPinSelected } = pinnedItins.actions
